import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { MutationDetailsAttributesFragmentDoc } from '../../../../contact/contact-form/graphql/contact.mutation.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type PriceListsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PriceListsQuery = { __typename?: 'HyperionSchemaQuery', company?: { __typename?: 'Company', priceLists?: { __typename?: 'PriceListConnection', edges?: Array<{ __typename?: 'PriceListEdge', node?: { __typename?: 'PriceList', id?: number | null, companyId?: number | null, name?: string | null, activeProjectCount?: number | null, contactCount?: number | null, projectCount?: number | null, userCostTypes?: Array<{ __typename?: 'PriceListUserCostType', id?: number | null, companyUserCostTypeId?: number | null, name?: string | null, active?: number | null, cost?: number | null } | null> | null, companyCostTypes?: Array<{ __typename?: 'PriceListCompanyCostType', id?: number | null, companyCostTypeId?: number | null, name?: string | null, active?: number | null, procent?: number | null } | null> | null, mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', argument?: string | null, errorsMsgs?: Array<string | null> | null, infoMsgs?: Array<string | null> | null, model?: string | null, modelErrorsMsgs?: Array<string | null> | null, modelSuccessMsgs?: Array<string | null> | null, modelWarningMsgs?: Array<string | null> | null, msg?: string | null, mutationSucceeded?: boolean | null, successMsgs?: Array<string | null> | null, warningMsgs?: Array<string | null> | null } | null> | null } | null } | null> | null } | null } | null };

export type PriceListFragment = { __typename?: 'PriceList', id?: number | null, companyId?: number | null, name?: string | null, activeProjectCount?: number | null, contactCount?: number | null, projectCount?: number | null, userCostTypes?: Array<{ __typename?: 'PriceListUserCostType', id?: number | null, companyUserCostTypeId?: number | null, name?: string | null, active?: number | null, cost?: number | null } | null> | null, companyCostTypes?: Array<{ __typename?: 'PriceListCompanyCostType', id?: number | null, companyCostTypeId?: number | null, name?: string | null, active?: number | null, procent?: number | null } | null> | null, mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', argument?: string | null, errorsMsgs?: Array<string | null> | null, infoMsgs?: Array<string | null> | null, model?: string | null, modelErrorsMsgs?: Array<string | null> | null, modelSuccessMsgs?: Array<string | null> | null, modelWarningMsgs?: Array<string | null> | null, msg?: string | null, mutationSucceeded?: boolean | null, successMsgs?: Array<string | null> | null, warningMsgs?: Array<string | null> | null } | null> | null };

export type CreatePriceListMutationVariables = Types.Exact<{
  name?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type CreatePriceListMutation = { __typename?: 'HyperionSchemaMutation', createPriceListMutation?: { __typename?: 'PriceList', id?: number | null, companyId?: number | null, name?: string | null, activeProjectCount?: number | null, contactCount?: number | null, projectCount?: number | null, userCostTypes?: Array<{ __typename?: 'PriceListUserCostType', id?: number | null, companyUserCostTypeId?: number | null, name?: string | null, active?: number | null, cost?: number | null } | null> | null, companyCostTypes?: Array<{ __typename?: 'PriceListCompanyCostType', id?: number | null, companyCostTypeId?: number | null, name?: string | null, active?: number | null, procent?: number | null } | null> | null, mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', argument?: string | null, errorsMsgs?: Array<string | null> | null, infoMsgs?: Array<string | null> | null, model?: string | null, modelErrorsMsgs?: Array<string | null> | null, modelSuccessMsgs?: Array<string | null> | null, modelWarningMsgs?: Array<string | null> | null, msg?: string | null, mutationSucceeded?: boolean | null, successMsgs?: Array<string | null> | null, warningMsgs?: Array<string | null> | null } | null> | null } | null };

export type UpdatePriceListMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']>;
  name?: Types.InputMaybe<Types.Scalars['String']>;
  userCostTypePrices?: Types.InputMaybe<Types.Scalars['String']>;
  companyCostTypePrices?: Types.InputMaybe<Types.Scalars['String']>;
  propagateToActiveProjects?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type UpdatePriceListMutation = { __typename?: 'HyperionSchemaMutation', updatePriceListMutation?: { __typename?: 'PriceList', id?: number | null, companyId?: number | null, name?: string | null, activeProjectCount?: number | null, contactCount?: number | null, projectCount?: number | null, userCostTypes?: Array<{ __typename?: 'PriceListUserCostType', id?: number | null, companyUserCostTypeId?: number | null, name?: string | null, active?: number | null, cost?: number | null } | null> | null, companyCostTypes?: Array<{ __typename?: 'PriceListCompanyCostType', id?: number | null, companyCostTypeId?: number | null, name?: string | null, active?: number | null, procent?: number | null } | null> | null, mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', argument?: string | null, errorsMsgs?: Array<string | null> | null, infoMsgs?: Array<string | null> | null, model?: string | null, modelErrorsMsgs?: Array<string | null> | null, modelSuccessMsgs?: Array<string | null> | null, modelWarningMsgs?: Array<string | null> | null, msg?: string | null, mutationSucceeded?: boolean | null, successMsgs?: Array<string | null> | null, warningMsgs?: Array<string | null> | null } | null> | null } | null };

export type DeletePriceListMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type DeletePriceListMutation = { __typename?: 'HyperionSchemaMutation', deletePriceListMutation?: { __typename?: 'PriceList', id?: number | null, mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', argument?: string | null, errorsMsgs?: Array<string | null> | null, infoMsgs?: Array<string | null> | null, model?: string | null, modelErrorsMsgs?: Array<string | null> | null, modelSuccessMsgs?: Array<string | null> | null, modelWarningMsgs?: Array<string | null> | null, msg?: string | null, mutationSucceeded?: boolean | null, successMsgs?: Array<string | null> | null, warningMsgs?: Array<string | null> | null } | null> | null } | null };

export const PriceListFragmentDoc = gql`
    fragment PriceList on PriceList {
  id
  companyId
  name
  activeProjectCount
  contactCount
  projectCount
  userCostTypes {
    id
    companyUserCostTypeId
    name
    active
    cost
  }
  companyCostTypes {
    id
    companyCostTypeId
    name
    active
    procent
  }
  mutationDetails {
    ...MutationDetailsAttributes
  }
}
    ${MutationDetailsAttributesFragmentDoc}`;
export const PriceListsDocument = gql`
    query priceLists {
  company {
    priceLists {
      edges {
        node {
          ...PriceList
        }
      }
    }
  }
}
    ${PriceListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PriceListsGQL extends Apollo.Query<PriceListsQuery, PriceListsQueryVariables> {
    document = PriceListsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePriceListDocument = gql`
    mutation createPriceList($name: String) {
  createPriceListMutation(name: $name) {
    ...PriceList
  }
}
    ${PriceListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePriceListGQL extends Apollo.Mutation<CreatePriceListMutation, CreatePriceListMutationVariables> {
    document = CreatePriceListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePriceListDocument = gql`
    mutation updatePriceList($id: Int, $name: String, $userCostTypePrices: String, $companyCostTypePrices: String, $propagateToActiveProjects: Boolean) {
  updatePriceListMutation(
    id: $id
    name: $name
    userCostTypePrices: $userCostTypePrices
    companyCostTypePrices: $companyCostTypePrices
    propagateToActiveProjects: $propagateToActiveProjects
  ) {
    ...PriceList
  }
}
    ${PriceListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePriceListGQL extends Apollo.Mutation<UpdatePriceListMutation, UpdatePriceListMutationVariables> {
    document = UpdatePriceListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePriceListDocument = gql`
    mutation deletePriceList($id: Int) {
  deletePriceListMutation(id: $id) {
    id
    mutationDetails {
      ...MutationDetailsAttributes
    }
  }
}
    ${MutationDetailsAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePriceListGQL extends Apollo.Mutation<DeletePriceListMutation, DeletePriceListMutationVariables> {
    document = DeletePriceListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }